import { type ReactNode } from 'react';

import styles from '@web/molecules/Widget/atoms/WidgetHeader/WidgetHeader.module.scss';

interface Props {
    children: ReactNode;
}

export const WidgetHeader = ({ children }: Props) => (
    <header className={styles['WidgetHeader']}>{children}</header>
);
